var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33329 0.666748C6.9651 0.666748 6.66663 0.965225 6.66663 1.33341V2.00008H3.33329C2.9651 2.00008 2.66663 2.29856 2.66663 2.66675C2.66663 3.03494 2.9651 3.33341 3.33329 3.33341H12.6666C13.0348 3.33341 13.3333 3.03494 13.3333 2.66675C13.3333 2.29856 13.0348 2.00008 12.6666 2.00008H9.33329V1.33341C9.33329 0.965225 9.03482 0.666748 8.66663 0.666748H7.33329Z",
    fill: "#F37766"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99996 6.00008C5.63177 6.00008 5.33329 6.29856 5.33329 6.66675V12.0001C5.33329 12.3683 5.63177 12.6667 5.99996 12.6667C6.36815 12.6667 6.66663 12.3683 6.66663 12.0001V6.66675C6.66663 6.29856 6.36815 6.00008 5.99996 6.00008Z",
    fill: "#F37766"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 6.00008C7.63177 6.00008 7.33329 6.29856 7.33329 6.66675V12.0001C7.33329 12.3683 7.63177 12.6667 7.99996 12.6667C8.36815 12.6667 8.66663 12.3683 8.66663 12.0001V6.66675C8.66663 6.29856 8.36815 6.00008 7.99996 6.00008Z",
    fill: "#F37766"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33329 6.66675C9.33329 6.29856 9.63177 6.00008 9.99996 6.00008C10.3681 6.00008 10.6666 6.29856 10.6666 6.66675V12.0001C10.6666 12.3683 10.3681 12.6667 9.99996 12.6667C9.63177 12.6667 9.33329 12.3683 9.33329 12.0001V6.66675Z",
    fill: "#F37766"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33329 4.66675C3.33329 4.29856 3.63177 4.00008 3.99996 4.00008H12C12.3681 4.00008 12.6666 4.29856 12.6666 4.66675V14.0001C12.6666 14.3683 12.3681 14.6667 12 14.6667H3.99996C3.63177 14.6667 3.33329 14.3683 3.33329 14.0001V4.66675ZM4.66663 13.3334V5.33342H11.3333V13.3334H4.66663Z",
    fill: "#F37766"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.1be291fa432689eed58ccb18404411a7.svg";
export { ForwardRef as ReactComponent };